const assignDepths = (nodes, depth = 0) => {
  nodes.forEach(node => {
    node.depth = depth;
    if (node.children?.length) {
      assignDepths(node.children, depth + 1);
    }
  });
};

const sortNodesByName = nodes => {
  nodes.sort((a, b) =>
    (a.label || '').localeCompare(b.label || '', undefined, { sensitivity: 'base' }),
  );
  nodes.forEach(node => {
    if (node.children?.length) {
      sortNodesByName(node.children);
    }
  });
};

const listToTree = (teams = {}) => {
  const nodeMap = Object.values(teams).reduce(
    (acc, curr) => ({
      ...acc,
      [curr._id]: { ...curr, id: curr._id, label: curr.name, children: [] },
    }),
    {},
  );
  const rootNodes = [];

  Object.values(nodeMap).forEach(currentNode => {
    const hasParentInMap = Object.prototype.hasOwnProperty.call(nodeMap, currentNode.parent);
    if (hasParentInMap) {
      nodeMap[currentNode.parent].children.push(currentNode);
    } else {
      rootNodes.push(currentNode);
    }
  });

  assignDepths(rootNodes);
  sortNodesByName(rootNodes);
  return rootNodes;
};

export default listToTree;
